/**
 * Print Record
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PrintRecordState = {
  printRecord: {
    entities: {},
    recordId: null,
    showDialog: false,
  },
}

export const PrintRecordActions = {
  getPrintRecordEntities: ({ commit }, req) => {
    return axiosRequest.
      get(`/records/${req.id}/print`).
      then(({ data }) => {
        commit('setPrintRecordEntities', data)
      }).
      catch(handleError)
  },
  printRecordSelection: ({ commit }, req) => {
    return axiosRequest.
      post(`/records/${req.id}/print`, { record: { selection: req.selection } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PrintRecordMutations = {
  setOnPrintRecord: (state, payload) => {
    state.printRecord.recordId = payload.recordId
    state.printRecord.showDialog = payload.showDialog
  },
  setPrintRecordEntities: (state, payload) => {
    state.printRecord.entities = payload
  },
  setShowPrintRecordDialog: (state, payload) => {
    state.printRecord.showDialog = payload
  },
}

export const PrintRecordGetters = {
  printRecordEntities: state => state.printRecord.entities,
  recordIdPrintRecord: state => state.printRecord.recordId,
  showDialogPrintRecord: state => state.printRecord.showDialog,
}
